import { useEffect, useState } from "react";
import MeetingHandler from "@/bussiness/MeetingHandler";
import IcWarning from "@/assets/svg/ic_warning.svg?react";
import IcInfo from "@/assets/svg/ic_info.svg?react";
import { toast, Id } from "react-toastify";
import recordStore from "@/store/record.store";
import Dialog from "@/component/Dialog";
import {
  handleStopRecording,
  handleResumeRecording,
} from "@/utils/recordingHandler";
import { listenOnline } from "@/utils/networkHelper";
import IcRecordFinishLoading from "@/assets/images/ic_record_finish_loading.png";
import timingStore from "@/store/timing.store";
import CommonLoading from "@/component/CommonLoading";

let toastId: Id;
let offlineOver30Flag = false;

export default function NoNetworkTip() {
  const [showModal, setShowModal] = useState(false);
  const pauseOrResumeLoading = timingStore(
    (state) => state.pauseOrResumeLoading
  );
  const finishLoading = timingStore((state) => state.finishLoading);

  useEffect(() => {
    const networkErrorHandler = () => {
      recordStore.getState().setOnline(false);
      // 通知前端网络异常
      toastId && toast.dismiss(toastId);
      offlineOver30Flag = false;
      toastId = toast.warning(`网络连接不稳定，转写暂停，音频持续录制中`, {
        autoClose: false,
        icon: IcWarning,
      });
      MeetingHandler.pauseRecord();

      // 开启轮询ping监听网络恢复，关闭异常提示, 并恢复录制
      listenOnline({
        offlineCb: (offlineSec: number) => {
          if (offlineSec > 30 && !offlineOver30Flag) {
            offlineOver30Flag = true;
            toastId && toast.dismiss(toastId);
            toastId = toast.error(`网络异常，请恢复后重试`, {
              autoClose: false,
            });
          }
        },
        onlineCb: (offlineSec: number) => {
          console.log("网络恢复");
          recordStore.getState().setOnline(true);
          toastId && toast.dismiss(toastId);
          toastId = toast.success(`网络已恢复，音频转写中`, {
            icon: IcInfo,
          });
          // 如果断网时长超过5分钟，弹窗询问用户是否记录进行录制
          if (offlineSec > 5 * 60) {
            setShowModal(true);
          }
          // 否则自动继续录制
          else {
            setTimeout(() => {
              console.log("3s 后重连 socket");
              MeetingHandler.resumeRecord();
            }, 3000);
          }
        },
      });
    };
    MeetingHandler.registerNetworkErrorHandler(networkErrorHandler);
  }, []);

  const onConfirm = async () => {
    await handleStopRecording();
    setShowModal(false);
  };

  const onCancel = async () => {
    await handleResumeRecording();
    setShowModal(false);
  };

  return (
    <Dialog
      isOpen={showModal}
      title={"检测到您已长时间断网，录制已暂停，确认是否继续当前录制？"}
      content={""}
      confirmText={
        finishLoading ? (
          <div className="px-5 flex items-center cursor-not-allowed">
            <CommonLoading src={IcRecordFinishLoading} className={`size-4`} />
          </div>
        ) : (
          "结束录制"
        )
      }
      cancelText={
        pauseOrResumeLoading ? (
          <div className="px-5 flex items-center cursor-not-allowed">
            <CommonLoading src={IcRecordFinishLoading} className={`size-4`} />
          </div>
        ) : (
          "继续录制"
        )
      }
      onConfirm={onConfirm}
      onCancel={onCancel}
    ></Dialog>
  );
}
